const svgIconsData = {
  'done-gen': 'https://cdn140.picsart.com/45200620217994999383.svg',
  'circle-done-gen': 'https://cdn140.picsart.com/91217014832892666643.svg',
  'add-gen': 'https://cdn140.picsart.com/45347279804967322091.svg',
  'arrow-down-gen': 'https://cdn140.picsart.com/57182939053417778514.svg',
  'arrow-down-small': 'https://cdn140.picsart.com/49426226925659987607.svg',
  'arrow-small-gen': 'https://cdn140.picsart.com/47202247813629196484.svg',
  'arrow-up-gen': 'https://cdn140.picsart.com/10742734823403607010.svg',
  'arrow-go-top': 'https://cdn140.picsart.com/77682750987509695302.svg',
  'collapse-arrow-down-gen': 'https://cdn140.picsart.com/56381396456408916451.svg',
  'collapse-arrow-up-gen': 'https://cdn140.picsart.com/05166466226910738881.svg',
  'checkmark-circle-gen': 'https://cdn140.picsart.com/61986774029633740475.svg',
  'checkmark-gen': 'https://cdn140.picsart.com/78046129580674208557.svg',
  'close-circle-gen': 'https://cdn140.picsart.com/96536051235671497319.svg',
  'close-fill-circle-gen': 'https://cdn140.picsart.com/02649555563664832869.svg',
  'close-circle-icon': 'https://cdn140.picsart.com/11259580931102410650.svg',
  'delete-gen': 'https://cdn140.picsart.com/55623035937347635928.svg',
  'download-gen': 'https://cdn140.picsart.com/09890029358736301078.svg',
  'download-process-gen': 'https://cdn140.picsart.com/85931853617247690176.svg',
  'format-gen': 'https://cdn140.picsart.com/09045377363614157252.svg',
  'upload-gen': 'https://cdn140.picsart.com/02007376801448793612.svg',
  'upload-gen-lite': 'https://cdn140.picsart.com/89674140250951181682.svg',
  'view-gen': 'https://cdn140.picsart.com/74016014143782421334.svg',
  'margin-original-gen': 'https://cdn140.picsart.com/64816381615930218350.svg',
  'margin-white-gen': 'https://cdn140.picsart.com/36804321410410691038.svg',
  'margin-xl-gen': 'https://cdn140.picsart.com/62378170794440931616.svg',
  'pdf-file-outline-gen': 'https://cdn140.picsart.com/74293114755301068150.svg',
  'converter-gen': 'https://cdn140.picsart.com/01644644243013448535.svg',
  'to-arrow-gen': 'https://cdn140.picsart.com/78656891681793249577.svg',
  'checkbox-unchecked-gen': 'https://cdn140.picsart.com/59758981901395203941.svg',
  'checkbox-checked-gen': 'https://cdn140.picsart.com/33137696615729475419.svg',
  'file-corner-gen': 'https://cdn140.picsart.com/92002448245710839963.svg',
  'arrow-big-gen': 'https://cdn140.picsart.com/60501083204709371281.svg',
  'info-circle-gen': 'https://cdn140.picsart.com/96289566312246539512.svg',
  'icon-circle-gen-black': 'https://cdn140.picsart.com/35870932923807865386.svg',
  'full-page-gen': 'https://cdn140.picsart.com/40499893208801212488.svg',
  'single-image-gen': 'https://cdn140.picsart.com/79792889503864287967.svg',
  'merge-illustration-gen': 'https://cdn140.picsart.com/36992222211569177870.svg',
  'drag-handle-gen': 'https://cdn140.picsart.com/22866396095044338004.svg',
  'chevron-right-gen': 'https://cdn140.picsart.com/01616326404448261582.svg',
  'chevron-down-gen': 'https://cdn140.picsart.com/01200490793845525885.svg',
  'arrow-right-gen': 'https://cdn140.picsart.com/00419410643776689871.svg',
  'arrow-next-gen': 'https://cdn140.picsart.com/19172135161632225481.svg',
  'play-gen': 'https://cdn140.picsart.com/28780649057841268663.svg',
  'a-letter-icon-gen': 'https://cdn140.picsart.com/60551399523966163411.svg',
  'magnifier-icon': 'https://cdn140.picsart.com/44352164637977702841.svg',
  'filter-icon': 'https://cdn140.picsart.com/47619915394839024680.svg',
  'chain-link': 'https://cdn140.picsart.com/44823772660317496945.svg',
  'large-plus': 'https://cdn140.picsart.com/82368224966147173141.svg',
  'checkmark-done': 'https://cdn140.picsart.com/11227404782971407621.svg',

  'arrow-long-gen': 'https://cdn140.picsart.com/68827203965941783173.svg',
  'pdf-split-illustration-gen': 'https://cdn140.picsart.com/87396912488092693421.svg',
  'retry-gen': 'https://cdn140.picsart.com/95196248594062199758.svg',

  'arrow-carrousel-left-gen': 'https://cdn140.picsart.com/16485133040975199894.svg',
  'arrow-carrousel-right-gen': 'https://cdn140.picsart.com/28053140959515033014.svg',

  'alert-icon-success-gen': 'https://cdn140.picsart.com/22575097289033392125.svg',
  'alert-icon-error-gen': 'https://cdn140.picsart.com/57423880715893586154.svg',
  'alert-icon-warning-gen': 'https://cdn140.picsart.com/40604870358190478441.svg',

  'try-again-icon-gen': 'https://cdn140.picsart.com/35582382119100320154.svg',
  'icon-reload': 'https://cdn140.picsart.com/02927750710693585619.svg',

  'upload-add-icon-gen': 'https://cdn140.picsart.com/87457456824130281624.svg',
  'card-folded-grey-rounded': 'https://cdn140.picsart.com/29455172715225866711.svg',
  'card-folded-grey-empty-icon': 'https://cdn140.picsart.com/27501421275989682149.svg',

  'convert-arrow-gen': 'https://cdn140.picsart.com/72264794233447034395.svg',

  // File icons
  'file-gen': 'https://cdn140.picsart.com/70790538276392651657.svg',
  'file-landscape-gen': 'https://cdn140.picsart.com/16123614324962302513.svg',
  'file-portrait-gen': 'https://cdn140.picsart.com/95112971574942843989.svg',
  'file-image-gen': 'https://cdn140.picsart.com/70790538276392651657.svg',
  'file-pdf-gen': 'https://cdn140.picsart.com/62673136006742620385.svg',
  'file-word-gen': 'https://cdn140.picsart.com/14336667225369007534.svg',
  'file-excel-gen': 'https://cdn140.picsart.com/31355807758448496352.svg',
  'file-powerpoint-gen': 'https://cdn140.picsart.com/47784559895757517884.svg',

  // Color Palette | cp
  'cp-add-element-gen': 'https://cdn140.picsart.com/74920971529504428740.svg',
  'cp-close-gen': 'https://cdn140.picsart.com/33086157698830895837.svg',
  'cp-undo-editor-gen': 'https://cdn130.picsart.com/78708136092812872846.svg',
  'cp-redo-editor-gen': 'https://cdn130.picsart.com/00466045111380628693.svg',
  'cp-download-gen': 'https://cdn140.picsart.com/55650514248695518918.svg',
  'cp-copy-link-gen': 'https://cdn140.picsart.com/74768329295373298144.svg',
  'cp-pdf-gen': 'https://cdn140.picsart.com/09030837107593352760.svg',
  'cp-qr-code-gen': 'https://cdn140.picsart.com/97249260042991270893.svg',
  'cp-done-gen': 'https://cdn140.picsart.com/56311537916163140601.svg',
  'cp-x-gen': 'https://cdn140.picsart.com/84119053877845779191.svg',
  'cp-delete-gen': 'https://cdn140.picsart.com/78199006377217477164.svg',
  'cp-shades-gen': 'https://cdn140.picsart.com/39201743690608965027.svg',
  'cp-unlock-gen': 'https://cdn140.picsart.com/32891110596475595513.svg',
  'cp-lock-gen': 'https://cdn140.picsart.com/22266337532929104653.svg',
  'cp-drag-gen': 'https://cdn140.picsart.com/59097204795499906133.svg',
  'copy-gen': 'https://cdn140.picsart.com/56732661552183359294.svg',
  'cp-adjust-editor-gen': 'https://cdn130.picsart.com/45141329682991742070.svg',
  'cp-gen': 'https://cdn140.picsart.com/02110673226388251740.svg',

  // Color Wheel
  'color-wheel-gen': 'https://cdn140.picsart.com/84482709743745687449.svg',
  'icon-copy': 'https://cdn140.picsart.com/31301221878857517266.svg',
  'undo-editor': 'https://cdn140.picsart.com/35143254268529857779.svg',
  'redo-editor': 'https://cdn140.picsart.com/63437080496258421417.svg',
  'tooltip-icon': 'https://cdn140.picsart.com/59573047260494426605.svg',
  'indicator-gen': 'https://cdn140.picsart.com/53302327615871505844.svg',
  'close-gen': 'https://cdn140.picsart.com/95328975622915354809.svg',
  'adjust-editor': 'https://cdn130.picsart.com/45141329682991742070.svg',
  'complementary-gen': 'https://cdn140.picsart.com/75949789341887808869.svg',
  'monochromatic-gen': 'https://cdn140.picsart.com/61163264942126801398.svg',
  'analogous-gen': 'https://cdn140.picsart.com/32143791418609230792.svg',
  'triadic-gen': 'https://cdn140.picsart.com/61449329830963217654.svg',
  'tetradic-gen': 'https://cdn140.picsart.com/42386050162954343721.svg',
  'thin-checkmark-gen': 'https://cdn140.picsart.com/08987096376759654294.svg',
  'arrow-down-small-gen': 'https://cdn140.picsart.com/42058686848929031683.svg',
  'loader-gen': 'https://cdn140.picsart.com/16929319565910240908.svg',
  'eye-dropper': 'https://cdn140.picsart.com/33296492967466892129.svg',

  // File large icons
  'png-file-gen': 'https://cdn140.picsart.com/61324311135662302507.svg',
  'pdf-file-gen': 'https://cdn140.picsart.com/55824539686503846238.svg',
  'jpg-file-gen': 'https://cdn140.picsart.com/64350913480206700338.svg',
  'word-file-gen': 'https://cdn140.picsart.com/05561662598380054089.svg',

  // File icons
  'doc-icon-gen': 'https://cdn140.picsart.com/32741202623021486703.svg',
  'pdf-icon-gen': 'https://cdn140.picsart.com/52634293496892794571.svg',
  'jpg-icon-gen': 'https://cdn140.picsart.com/42301361024982987559.svg',
  'png-icon-gen': 'https://cdn140.picsart.com/57867740095106720243.svg',
  'video-file-gen': 'https://cdn140.picsart.com/17274323035368164110.svg',
  'video-file-big-gen': 'https://cdn140.picsart.com/88038691796462811298.svg',

  // Word counter
  'num-logo-gen': 'https://cdn140.picsart.com/94600583296957003777.svg',

  // Picsart Main Icons - this are the latest icons
  'picsart-main-icons-preview': 'https://cdn140.picsart.com/35082516549079509755.svg',
  'picsart-main-icons-delete': 'https://cdn140.picsart.com/71180185341228540040.svg',
  'picsart-main-icons-download': 'https://cdn140.picsart.com/32022511750544381574.svg',
  'picsart-main-icons-upload': 'https://cdn140.picsart.com/70058173693402895160.svg',
  'picsart-main-icons-before-after-edit': 'https://cdn140.picsart.com/43656358370495444630.svg',
};

export default svgIconsData;
